import { getMostRecentFieldValue } from '@fs/zion-sls'
import React from 'react'

export const getFieldValues = (elements) => {
  return elements
    ?.flatMap(
      (element) =>
        element.subElements?.flatMap((subElement) => ({
          displayLabel: subElement?.displayLabel,
          value: getMostRecentFieldValue(subElement),
          id: subElement?.id,
          fieldType: subElement?.fieldType,
          superElements: subElement?.superElements,
          personId: subElement?.personId,
        })) || []
    )
    .filter((field) => field.value)
}

export default function FieldDisplay({ heading, values }) {
  return (
    <>
      {heading && (
        <>
          <strong>{heading}</strong>
          <br />
        </>
      )}
      {values.map(
        ({ displayLabel, value, id }) =>
          value &&
          displayLabel &&
          displayLabel !== '<Unknown Type>' && (
            <span key={id}>
              {displayLabel}: {value}
              <br />
            </span>
          )
      )}
    </>
  )
}
